export const USER_TOKEN_KEY = 'userToken'
export const USER_LOGIN_PAGE_KEY = 'userLoginPage'
export const DAILY_SHARE_KEY = 'dailyShare'
